import React, { memo } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import styles from './styles.module.scss';

import exploreBtn from '../../assets/img/public/icons/exploreBtn.svg';

const Index = memo((props) => {

  const dispatch = useDispatch();
  const { handleNewsDetail } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const localesReducer = useSelector(({localesReducer}) => localesReducer.i18n);
  const { value: scrollNumReducer, cshVal } = useSelector(({scrollNumReducer}) => scrollNumReducer);

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return styles.normalSm;
    }
  };

  // 判断是：桌面/移动端
  const desktopMobile = () => {
    const { bgImg, title } = props.config;
    return (
        <div
            className={normal()}
            ref={props.config.getRefs.innerBgRef}
            style={{
              background: `url(${bgImg}) no-repeat 100% 100% / cover`,
              ...props.config.getRefs.innerBgStyles
            }}
        >
          <div className="innerBannerInfo">
            <h4 
                className="title"
                ref={props.config.getRefs.innerTextRef}
                style={props.config.getRefs.innerTextStyles}
            >
              <span>{title}</span>
            </h4>
            {/* <i className="nextBtn"><img src={exploreBtn} alt="" /></i> */}
          </div>
        </div>
    );
  };


  return desktopMobile();
});
export default Index;
